import { render, staticRenderFns } from "./TdDeviceInfo.vue?vue&type=template&id=2a25ed04&scoped=true&"
import script from "./TdDeviceInfo.vue?vue&type=script&lang=js&"
export * from "./TdDeviceInfo.vue?vue&type=script&lang=js&"
import style0 from "./TdDeviceInfo.vue?vue&type=style&index=0&id=2a25ed04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a25ed04",
  null
  
)

export default component.exports